<script>
import baseMixin from '@/mixins/baseMixin'
import formMixin from '@/mixins/formMixin'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'CreateLoginDialogAndButton',
  mixins: [baseMixin, formMixin],
  props: {
    candidateId: {
      type: Number,
      required: true,
    },
    candidateName: {
      type: String,
      required: true,
    },
  },
  data: () => {
    return {
      dialog: false,
    }
  },
  computed: {
    ...mapGetters({
      isLoadingCandidateUserDetailsCRUD:
        'candidate/isLoadingCandidateUserDetailsCRUD',
    }),
  },
  methods: {
    ...mapActions({
      createLogin: 'candidate/createLogin',
    }),
    async handleCreateLogin() {
      const response = await this.createLogin({
        candidateId: this.candidateId,
      })

      if (!response.isSuccess) return

      this.$emit('login-created')

      this.dialog = false
    },
  },
}
</script>

<template>
  <v-dialog v-model="dialog" fullscreen transition="dialog-bottom-transition">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        id="create-login-button"
        color="primary"
        v-bind="attrs"
        v-on="on"
        >{{ $t('candidate.createLoginBtnLabel') }}</v-btn
      >
    </template>
    <v-card id="create-login-dialog-card" tile class="overflow-x-hidden">
      <h6 class="text-h6">{{ $t('candidate.createLoginDialogTitle') }}</h6>
      <p class="text-body-2">{{
        $t('candidate.createLoginDialogPrompt', { candidateName })
      }}</p>
      <v-spacer></v-spacer>
      <v-card-actions class="justify-end pa-0">
        <v-btn
          class="mr-2"
          color="primary"
          text
          :disabled="isLoadingCandidateUserDetailsCRUD"
          @click="dialog = false"
        >
          {{ $t('general.cancel') }}
        </v-btn>
        <v-btn
          id="create-button"
          color="primary"
          :loading="isLoadingCandidateUserDetailsCRUD"
          @click="handleCreateLogin"
        >
          {{ $t('general.create') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
